(function () {
  'use strict';

  var helper = require('./generic.js');
  var settings = require('./settings.js');

  module.exports = Logger;
  function Logger(prefix){
    this.prefix = prefix;
    this._debugEnabled = true; //debugging is always enabled at first as you have to explicitely enable debug output for all instances via settings.enableDebugging();
  }

  Logger.prototype = {

    _getColorString: function _getColorString(){
      return this._getColorStringForColor(this.color);
    },
    _getColorStringForColor: function _getColorStringForColor(color){
      var str = "color:";
      if (helper.undefOrNull(color)){
        str += "#005500";
      } else {
        str += color;
      }
      str += ";";
      return str;
    },
    _doLog: function _doLog(type, extraPrefixObject, message, obj){
      if (!settings.getIgnoredLoggers().includes(this.prefix)){
        var params = [];
        if (helper.undefOrNull(this.prefix) && helper.undefOrNull(extraPrefixObject)){
          params.push(message);
        } else {
          var styles = [];

          var prefixedMessage = "";
          if (!helper.undefOrNull(this.prefix)){
            prefixedMessage += "%c" + this.prefix;
            styles.push(this._getColorString());
          }
          if (!helper.undefOrNull(extraPrefixObject)){
            if (prefixedMessage.length>0){
              prefixedMessage += " ";
            }
            prefixedMessage += "%c" + extraPrefixObject.text;
            styles.push(extraPrefixObject.style);
          }
          prefixedMessage += ":%c " + message;
          styles.push('color: blue;'); //message color = blue

          params.push(prefixedMessage);
          params = params.concat(styles); //blue=debug
        }
        // obj is always last
        if (!helper.undefOrNull(obj)){
          params.push(obj);
        }

        if (type == 'debug' || type == 'deprecation'){
          console.debug.apply(this, params);
        } else if (type == 'error'){
          console.error.apply(this, params);
        } else if (type == 'log'){
          console.log.apply(this, params);
        } else if (type == 'info'){
          console.info.apply(this, params);
        } else if (type == 'warn'){
          console.warn.apply(this, params);
        } else {
          throw "not yet supported";
        }
      }
    },
    deprecation: function deprecation(message, obj){
      if (settings.deprecationWarningsEnabled()){
        this._doLog("deprecation", {text: "DEPRECATED", style: "color:red; font-weight: bold;"}, message, obj);
      }
      return this;
    },
    debug: function debug(message, obj){
      if (this.debuggingEnabled()){
        this._doLog("debug", null, message, obj);
      }
      return this;
    },
    error: function error(message, obj){
      this._doLog("error", null, message, obj);
      return this;
    },
    warn: function warn(message, obj){
      this._doLog("warn", null, message, obj);
      return this;
    },
    info: function info(message, obj){
      this._doLog("info", null, message, obj);
      return this;
    },
    log: function log(message, obj){
      this._doLog("log", null, message, obj);
      return this;
    },
    setPrefix: function setPrefix(prefix){
      this.prefix = prefix;
      return this;
    },
    setColor: function setColor(color){
      this.color = color;
      return this;
    },
    setDebug: function setDebug(bool){
      this._debugEnabled = bool;
      return this;
    },
    debuggingEnabled: function debuggingEnabled(){
      if (this._debugEnabled){
        return settings.debuggingEnabled();
      } else {
        return false;
      }
    },
  };


}());



//////////////////
// WEBPACK FOOTER
// ./src/helpers/logger.js
// module id = 3
// module chunks = 0